import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomInstagram({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="currentColor" fillRule="nonzero">
        <path d="M13.669 2H6.33A4.336 4.336 0 002 6.331v7.338A4.336 4.336 0 006.331 18h7.338A4.336 4.336 0 0018 13.67V6.33A4.336 4.336 0 0013.669 2zm3.393 11.67a3.397 3.397 0 01-3.393 3.392H6.33a3.397 3.397 0 01-3.393-3.393V6.331a3.397 3.397 0 013.393-3.393h7.338a3.397 3.397 0 013.393 3.393v7.338z" />
        <path d="M10 5.368A4.637 4.637 0 005.368 10 4.637 4.637 0 0010 14.632 4.637 4.637 0 0014.632 10 4.637 4.637 0 0010 5.368zm0 8.27A3.643 3.643 0 016.361 10 3.643 3.643 0 0110 6.361 3.643 3.643 0 0113.639 10 3.643 3.643 0 0110 13.639zM14.21 3.684c-.696 0-1.263.567-1.263 1.263 0 .697.567 1.264 1.263 1.264a1.265 1.265 0 000-2.526zm0 1.684a.422.422 0 11.002-.843.422.422 0 01-.002.843z" />
      </g>
    </svg>
  );
}
export default SvgIconCustomInstagram;
